import { Office } from '@gettactic/api';
import { OfficeBuildingIcon } from '@heroicons/react/outline';
import React from 'react';
import { Flex } from '../../../primitives';
import { cn } from '@gettactic/helpers/src';

export interface OfficeLabelProps {
  office: Office | undefined | null;
  className?: string;
  iconClassName?: string;
}

export const OfficeLabel: React.FC<OfficeLabelProps> = ({
  office,
  className,
  iconClassName
}) => {
  if (!office) return null;
  return (
    <Flex className={cn('items-center gap-2', className)}>
      <OfficeBuildingIcon
        className={cn('size-5 shrink-0 text-secondary [.tactic-v2_&]:text-secondary-foreground', iconClassName)}
      />
      {office.name}
    </Flex>
  );
};
